import { defineComponent as _defineComponent } from 'vue'
import ListOffer from '@/features/buybox/components/list/ListOffer.vue';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { COUNTRY_EXCEPTIONS } from '@/constants/web-locales.constant';
import { mrcObservableOptions } from '@/helpers/composables/useBatchImpressionTracking';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { provideLocal } from '@vueuse/core';
import { computed, ref } from 'vue';
import { useInternationalOffersTracking } from '../tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyboxInternationnalOffersRow',
  props: {
    titleId: null,
    title: null,
    offers: null,
    country: null,
    index: null,
    isEpisodeBuybox: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	titleId: string;
	title: TitleDetail;
	offers: TitleOfferFragment[];
	country: string;
	index: number;
	isEpisodeBuybox?: boolean;
};



const showOffers = ref(props.index === 0);
const { trackInternationalOffers } = useInternationalOffersTracking({ title: () => props.title });

const expressVPNhref = 'https://go.expressvpn.com/c/1206980/1645830/16063';

const toggle = () => {
	showOffers.value = !showOffers.value;

	trackInternationalOffers('countryDropdownExpand', {
		spec: {
			property: props.country,
			value: showOffers.value ? 1 : 0,
		},
	});
};

const computedCountry = computed(() => {
	return props.country;
});

provideLocal('row-country', computedCountry);

const countryFlag = computed(() => {
	const country = COUNTRY_EXCEPTIONS[props.country.toLowerCase()]
		? COUNTRY_EXCEPTIONS[props.country.toLowerCase()]
		: props.country;
	return `${JW_CONFIG.ASSETS_URL}/flags/${country.toUpperCase()}.png`;
});

const expressVpnLogo = computed(() => {
	return `/${ASSETS_DIR}/img/icons/express-vpn.png`;
});

const uniqueOffers = computed(() => {
	const uniqueOffersMap = new Map<number, TitleOfferFragment>();
	props.offers.forEach(offer => {
		if (!uniqueOffersMap.has(offer.package.packageId)) {
			uniqueOffersMap.set(offer.package.packageId, offer);
		}
	});
	return Array.from(uniqueOffersMap.values());
});

function trackExpressVPNClick() {
	trackInternationalOffers('vpnClickout', { spec: { label: props.country } });
}

function trackVPNOfferImpression(isVisible: boolean) {
	if (isVisible) {
		trackInternationalOffers('vpnOfferImpression', { spec: { label: props.country } });
	}
}

return { __sfc: true,props, showOffers, trackInternationalOffers, expressVPNhref, toggle, computedCountry, countryFlag, expressVpnLogo, uniqueOffers, trackExpressVPNClick, trackVPNOfferImpression, ListOffer, ProviderIcon, mrcObservableOptions, faChevronDown, faChevronUp, FontAwesomeIcon }
}

})